// extracted by mini-css-extract-plugin
export var devOnlyTitle = "ErrorBanner-module__devOnlyTitle___RcLNE";
export var errorPageContainer = "ErrorBanner-module__errorPageContainer___Jo-kD";
export var wrapper = "ErrorBanner-module__wrapper___pa24+";